/* eslint-disable prettier/prettier */
/**
 * 人员选择器，组件入口
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { useEffect, useMemo, useState } from 'react';
import { SelectorMode } from './types';
import UserSelectionContext from './context';
import LeftSide, { LeftSideFixedUsers, LeftSideFixedUsersRosters, LeftSideStrangerUsersRosters, } from './LeftSide';
import RightSide from './RightSide';
import { uniqBy } from 'lodash';
import { message } from 'antd';
import InputAreaContext from '../UserSelectionModal/context';
import Loading from '../Loading';
import events from '../events';
export * from './types';
export default function UserSelection(props) {
    var fixedUsers = props.fixedUsers, resultUsers = props.resultUsers, frozenIds = props.frozenIds, single = props.single, defaultUserAvatar = props.defaultUserAvatar, t = props.t, searchPlaceHolder = props.searchPlaceHolder, hasItemSelector = props.hasItemSelector, itemSelectorOptions = props.itemSelectorOptions, 
    // customTab,
    // customTab2,
    customTabs = props.customTabs, canSelectDept = props.canSelectDept, _a = props.canSelectAll, canSelectAll = _a === void 0 ? true : _a, businessTab = props.businessTab, recommendParam = props.recommendParam, leaveWordInputValue = props.leaveWordInputValue, extraInputValue = props.extraInputValue, despInputValue = props.despInputValue, strangerLeaveWordInputValue = props.strangerLeaveWordInputValue, onInputLeaveWordChange = props.onInputLeaveWordChange, onInputStrangerLeaveWordChange = props.onInputStrangerLeaveWordChange, onInputExtraChange = props.onInputExtraChange, onInputDespChange = props.onInputDespChange, _b = props.mode, mode = _b === void 0 ? SelectorMode.user : _b, bodyHeight = props.bodyHeight, customAreaExtra = props.customAreaExtra, rightExtra = props.rightExtra, rightHeaderExtra = props.rightHeaderExtra, _c = props.maxSelectedNum, maxSelectedNum = _c === void 0 ? 1000 : _c, _d = props.maxSelectedSingleNum, maxSelectedSingleNum = _d === void 0 ? 1000 : _d, isForwardMode = props.isForwardMode, _e = props.isShowRemark, isShowRemark = _e === void 0 ? true : _e, dataListFilter = props.dataListFilter, chooseOnlyDepart = props.chooseOnlyDepart, selectedCountText = props.selectedCountText, canSelectStranger = props.canSelectStranger, defaultLimitOpt = props.defaultLimitOpt, selectedLimit = props.selectedLimit, setSelectedLimit = props.setSelectedLimit;
    var _f = useState(true), loading = _f[0], setLoading = _f[1];
    var onResultChange = props.onResultChange, onGetAvatarURL = props.onGetAvatarURL, onGetEBookDeptInfo = props.onGetEBookDeptInfo, onGetEBookWorkLineInfo = props.onGetEBookWorkLineInfo, onGetEBookOrgInfo = props.onGetEBookOrgInfo, onSearchGlobal = props.onSearchGlobal, onSearchStranger = props.onSearchStranger, onGetRecentData = props.onGetRecentData, onGetRecentIncludeGroup = props.onGetRecentIncludeGroup, onGetAgentForData = props.onGetAgentForData, onGetTopData = props.onGetTopData, onGetExternalContacts = props.onGetExternalContacts, onGetTagData = props.onGetTagData, onGetTagMembersData = props.onGetTagMembersData, onGetGroupData = props.onGetGroupData, onGetGroupMembersData = props.onGetGroupMembersData, onGetBusinessData = props.onGetBusinessData, onGetRecommendInfo = props.onGetRecommendInfo, onSearchGroupMember = props.onSearchGroupMember, getSearchExtraPart = props.getSearchExtraPart, simpleDeptInfoList = props.simpleDeptInfoList, virtualDeptInfoList = props.virtualDeptInfoList, currentUser = props.currentUser, contactsFilterFlag = props.contactsFilterFlag, contactShowType = props.contactShowType, selectGroupType = props.selectGroupType, onAnalysisLog = props.onAnalysisLog, 
    // onSelectedChange
    _g = props.smallModal, 
    // onSelectedChange
    smallModal = _g === void 0 ? false : _g;
    var tabsParams = props.tabs || [];
    if (!onGetTagData || !onGetTagMembersData) {
        var tagIdx = tabsParams.findIndex(function (i) { return i === 'tag'; });
        if (tagIdx >= 0) {
            tabsParams.splice(tagIdx, 1);
        }
    }
    var _h = React.useContext(InputAreaContext), newMode = _h.newMode, strangerResult = _h.strangerResult, setStrangerResult = _h.setStrangerResult;
    var _j = React.useState(), searchValue = _j[0], setSearchValue = _j[1];
    var _k = React.useState(resultUsers || []), result = _k[0], setResult = _k[1];
    var _l = React.useState(true), isWebpSupported = _l[0], setIsWebpSupported = _l[1];
    var hiddenUsers = (resultUsers === null || resultUsers === void 0 ? void 0 : resultUsers.filter(function (item) { return item.visible === false; })) || [];
    var maxNumber = ((selectedLimit === null || selectedLimit === void 0 ? void 0 : selectedLimit.limit) || (maxSelectedNum > 1000 ? 1000 : maxSelectedNum)) - hiddenUsers.length;
    if (maxNumber < 0)
        maxNumber = 0;
    var maxSingleNumber = maxSelectedSingleNum > 1000 ? 1000 : maxSelectedSingleNum;
    var _m = useState(__spreadArrays(tabsParams)), filteredTabs = _m[0], setFilteredTabs = _m[1];
    useEffect(function () {
        if (tabsParams && tabsParams.length > 1 && tabsParams.includes('workLine')) {
            onGetEBookWorkLineInfo({
                nodeId: '',
                version: 0,
            })
                .then(function (res) {
                if (res && res.parentNodeList.length === 0 && res.subNodeList.length === 0) {
                    setFilteredTabs(function (prev) {
                        var data = prev;
                        // eslint-disable-next-line max-nested-callbacks
                        var i = prev.findIndex(function (i) { return i === 'workLine'; });
                        if (i >= 0) {
                            data.splice(i, 1);
                        }
                        return data;
                    });
                }
                setLoading(false);
            })
                .catch(function (e) {
                message.error(e);
                setLoading(false);
            });
        }
        else {
            setLoading(false);
        }
        return function () { };
    }, [onGetEBookWorkLineInfo, tabsParams]);
    React.useEffect(function () {
        if (onResultChange) {
            onResultChange(newMode === SelectorMode.stranger ? strangerResult : result);
        }
    }, [result, onResultChange, newMode, strangerResult]);
    var supportsWebp = React.useCallback(function (_a) {
        var createImageBitmap = _a.createImageBitmap, Image = _a.Image;
        if (!createImageBitmap || !Image)
            return Promise.resolve(false);
        return new Promise(function (resolve) {
            var image = new Image();
            image.onload = function () {
                createImageBitmap(image)
                    .then(function () {
                    resolve(true);
                })
                    .catch(function () {
                    resolve(false);
                });
            };
            image.onerror = function () {
                resolve(false);
            };
            image.src =
                'data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=';
        });
    }, []);
    var webpIsSupported = React.useCallback(function () {
        var memo = null;
        return function () {
            if (!memo) {
                memo = supportsWebp(window);
            }
            return memo;
        };
    }, [supportsWebp]);
    React.useEffect(function () {
        // 添加浏览器是否支持webp格式判断
        webpIsSupported()()
            // eslint-disable-next-line max-nested-callbacks
            .then(function (res) {
            // console.log('是否支持 webp', res);
            setIsWebpSupported(res);
        })
            // eslint-disable-next-line max-nested-callbacks
            .catch(function (err) {
            console.log(err);
        });
    }, []); // eslint-disable-line
    var addItem = React.useCallback(function (item) {
        var res = newMode === SelectorMode.stranger ? strangerResult : result;
        var idx = res.findIndex(function (a) { return a.id === item.id; });
        if (idx >= 0) {
            return;
        }
        if (single) {
            newMode === SelectorMode.stranger ? setStrangerResult([item]) : setResult([item]);
            return;
        }
        var visibleData = result.filter(function (item1) { return item.visible !== false; });
        if (isForwardMode) {
            var list = uniqBy(__spreadArrays(visibleData, strangerResult), 'id');
            var groups = list.filter(function (item1) { return item1.isGroup; }) || [];
            var singles = list.filter(function (item1) { return !item1.isGroup; }) || [];
            if ((groups.length >= maxNumber && item.isGroup) ||
                (singles.length >= maxSingleNumber && !item.isGroup) ||
                groups.length + singles.length >= maxNumber + maxSingleNumber) {
                message.error("\u9009\u62E9\u4F1A\u8BDD\u6570\u76EE\u5355\u804A\u4E0D\u80FD\u8D85\u8FC7" + maxSingleNumber + "\u4E2A\uFF0C\u7EC4\u6C9F\u901A\u4E0D\u80FD\u8D85\u8FC7" + maxNumber + "\u4E2A\u3002");
                return;
            }
        }
        else if (maxNumber > -1 &&
            uniqBy(__spreadArrays(visibleData, strangerResult), 'id').length - hiddenUsers.length >= maxNumber) {
            var errText = (maxSelectedNum || defaultLimitOpt) ? "人数已达上限，无法再选择更多人员加入" : "\u9009\u62E9\u6570\u76EE\u8D85\u8FC7\u4E0A\u9650" + maxNumber;
            // 已选人数上限1000人 （大于1000提示1000）
            message.error(errText);
            return;
        }
        var data = __spreadArrays(res, [item]);
        newMode === SelectorMode.stranger ? setStrangerResult(data) : setResult(data);
    }, [newMode, strangerResult, result, single, isForwardMode, maxNumber, hiddenUsers, setStrangerResult, maxSingleNumber, maxSelectedNum, defaultLimitOpt]);
    var removeItem = React.useCallback(function (item) {
        if (newMode !== SelectorMode.stranger) {
            var idx = result.findIndex(function (a) { return a.id === item.id; });
            if (idx < 0) {
                return;
            }
            var data = __spreadArrays(result.slice(0, idx), result.slice(idx + 1));
            setResult(data);
        }
        else {
            var resultIdx = result.findIndex(function (a) { return a.id === item.id; });
            var strangerIdx = strangerResult.findIndex(function (a) { return a.id === item.id; });
            if (strangerIdx > -1) {
                var strangerData = __spreadArrays(strangerResult.slice(0, strangerIdx), strangerResult.slice(strangerIdx + 1));
                setStrangerResult(strangerData);
            }
            if (resultIdx > -1) {
                var resultData = __spreadArrays(result.slice(0, resultIdx), result.slice(resultIdx + 1));
                setResult(resultData);
            }
        }
    }, [newMode, result, setStrangerResult, strangerResult]);
    var totalCount = useMemo(function () {
        if (newMode === SelectorMode.stranger) {
            return strangerResult.length;
        }
        var res = __spreadArrays(result.filter(function (item) { return item.visible !== false; }), strangerResult);
        if (res.length === 0) {
            return 0;
        }
        return (res || []).reduce(function (total, item) {
            var tempTotal = total;
            // if (item.isDept) {
            //     const { contactNumber } = item.origin;
            //     tempTotal += isNumber(contactNumber) ? contactNumber : 0;
            // } else {
            tempTotal += 1;
            // }
            return tempTotal;
        }, 0);
    }, [newMode, result, strangerResult]);
    useEffect(function () {
        function onClear() {
            setResult([]);
        }
        function onSetSelectedLimit(payload) {
            console.log('onSetSelectedLimit:', payload);
            console.log('totalCount:', totalCount);
            var opt = payload.opt, cb = payload.cb;
            if (totalCount > (opt === null || opt === void 0 ? void 0 : opt.limit)) {
                message.error('已选成员数量超过了切换的人数上限，请移除一些成员后再试。');
                cb === null || cb === void 0 ? void 0 : cb({ status: 'failed' });
                return;
            }
            setSelectedLimit(opt);
            cb === null || cb === void 0 ? void 0 : cb({ status: 'success', selected: opt });
        }
        events.on('clear', onClear);
        events.on('setSelectedLimit', onSetSelectedLimit);
        return function () {
            events.off('clear', onClear);
            events.off('setSelectedLimit', onSetSelectedLimit);
        };
    }, [setSelectedLimit, totalCount]);
    // 修改数据
    var onChangeItem = React.useCallback(function (item, options) {
        if (options === void 0) { options = {}; }
        var res = newMode === SelectorMode.stranger ? strangerResult : result;
        var idx = res.findIndex(function (a) { return a.id === item.id; });
        if (idx < 0) {
            return;
        }
        res.splice(idx, 1, __assign(__assign({}, item), options));
        // console.log(result, 'onChangeItemonChangeItemonChangeItemonChangeItem')
        var data = __spreadArrays(res);
        newMode === SelectorMode.stranger ? setStrangerResult(data) : setResult(data);
    }, [newMode, result, setStrangerResult, strangerResult]);
    // 修改数据
    var onChangeDataAll = React.useCallback(function (options) {
        if (options === void 0) { options = {}; }
        var res = newMode === SelectorMode.stranger ? strangerResult : result;
        var resMap = res.map(function (item) {
            return __assign(__assign({}, item), options);
        });
        // console.log(resMap, 'onChangeDataAllonChangeDataAllonChangeDataAllonChangeDataAll')
        // setResult([...resMap]);
        var data = __spreadArrays(resMap);
        newMode === SelectorMode.stranger ? setStrangerResult(data) : setResult(data);
    }, [newMode, result, setStrangerResult, strangerResult]);
    var toggleItem = React.useCallback(function (item) {
        if (item.checked) {
            // radio 只选择一个，不删除
            if (single) {
                return;
            }
            // 冻结 item 不删除
            if (Array.isArray(frozenIds) && frozenIds.findIndex(function (id) { return id === item.id; }) >= 0) {
                return;
            }
            removeItem(item);
        }
        else {
            addItem(item);
        }
    }, [addItem, frozenIds, removeItem, single]);
    var selectAllItems = function (dataList, specialGroup) {
        var tempList = newMode === SelectorMode.stranger ? strangerResult : result;
        var _loop_1 = function (item) {
            if (Array.isArray(frozenIds) && frozenIds.findIndex(function (id) { return id === item.id; }) >= 0) {
                return "continue";
            }
            var idx = tempList.findIndex(function (a) { return a.id === item.id; });
            if (idx < 0) {
                tempList.push(item);
            }
        };
        for (var _i = 0, dataList_1 = dataList; _i < dataList_1.length; _i++) {
            var item = dataList_1[_i];
            _loop_1(item);
        }
        // setResult([...tempList]);
        var data = __spreadArrays(tempList);
        newMode === SelectorMode.stranger ? setStrangerResult(data) : setResult(data);
    };
    var unSelectAllItems = function (dataList, specialGroup) {
        var tempList = newMode === SelectorMode.stranger ? strangerResult : result;
        var list = dataList;
        if ((frozenIds || []).length > 0) {
            list = dataList.filter(function (item) { return frozenIds && !frozenIds.includes(item.id); });
        }
        var _loop_2 = function (item) {
            var idx = tempList.findIndex(function (a) { return a.id === item.id; });
            if (idx >= 0) {
                tempList.splice(idx, 1);
            }
        };
        for (var _i = 0, list_1 = list; _i < list_1.length; _i++) {
            var item = list_1[_i];
            _loop_2(item);
        }
        var data = __spreadArrays(tempList);
        newMode === SelectorMode.stranger ? setStrangerResult(data) : setResult(data);
    };
    var onSelectAll = function (dataList, allChecked, specialGroup) {
        if (dataList.length === 0) {
            return null;
        }
        if (allChecked) {
            selectAllItems(dataList, specialGroup);
        }
        else {
            unSelectAllItems(dataList, specialGroup);
        }
    };
    var leftSideFixedUsers = React.useMemo(function () {
        return (React.createElement(LeftSideFixedUsers, { result: result, onSearchGlobal: onSearchGlobal, onItemCheck: function (item) {
                toggleItem(item);
            } }));
    }, [onSearchGlobal, result, toggleItem]);
    var leftSideFixedUsersRosters = React.useMemo(function () {
        return (React.createElement(LeftSideFixedUsersRosters, { result: result, onItemCheck: function (item) {
                toggleItem(item);
            }, onSearchGroupMember: onSearchGroupMember }));
    }, [onSearchGroupMember, result, toggleItem]);
    var leftSideStrangerUsers = React.useMemo(function () {
        return (React.createElement(LeftSideStrangerUsersRosters, { result: result, strangerResult: strangerResult, onSearchStranger: onSearchStranger, onItemCheck: function (item) {
                toggleItem(item);
            }, getSearchExtraPart: getSearchExtraPart }));
    }, [getSearchExtraPart, onSearchStranger, result, strangerResult, toggleItem]);
    var leftSide = React.useMemo(function () {
        return (React.createElement(LeftSide, { result: result, onItemCheck: function (item) {
                toggleItem(item);
            }, onGetEBookDeptInfo: onGetEBookDeptInfo, onGetEBookWorkLineInfo: onGetEBookWorkLineInfo, onGetEBookOrgInfo: onGetEBookOrgInfo, onSearchGlobal: onSearchGlobal, onGetRecentData: onGetRecentData, onGetRecentIncludeGroup: onGetRecentIncludeGroup, onGetAgentForData: onGetAgentForData, onGetTopData: onGetTopData, onGetExternalContacts: onGetExternalContacts, onGetGroupData: onGetGroupData, onGetGroupMembersData: onGetGroupMembersData, onGetTagData: onGetTagData, onGetTagMembersData: onGetTagMembersData, onGetBusinessData: onGetBusinessData, onGetRecommendInfo: onGetRecommendInfo, onSearchGroupMember: onSearchGroupMember, getSearchExtraPart: getSearchExtraPart, onAnalysisLog: onAnalysisLog, onInputStrangerLeaveWordChange: onInputStrangerLeaveWordChange }));
    }, [
        result,
        onGetEBookDeptInfo,
        onGetEBookWorkLineInfo,
        onGetEBookOrgInfo,
        onSearchGlobal,
        onGetRecentData,
        onGetRecentIncludeGroup,
        onGetAgentForData,
        onGetTopData,
        onGetExternalContacts,
        onGetGroupData,
        onGetGroupMembersData,
        onGetTagData,
        onGetTagMembersData,
        onGetBusinessData,
        onGetRecommendInfo,
        onSearchGroupMember,
        getSearchExtraPart,
        onAnalysisLog,
        onInputStrangerLeaveWordChange,
        toggleItem,
    ]);
    var rightSide = React.useMemo(function () {
        if (smallModal) {
            return null;
        }
        return (React.createElement(RightSide, { data: result.filter(function (item) { return item.visible !== false; }), onItemDelete: function (data) {
                toggleItem(__assign(__assign({}, data), { checked: true }));
            }, onInputLeaveWordChange: onInputLeaveWordChange, onInputStrangerLeaveWordChange: onInputStrangerLeaveWordChange, onInputDespChange: onInputDespChange, onInputExtraChange: onInputExtraChange, despInputValue: despInputValue, extraInputValue: extraInputValue, strangerLeaveWordInputValue: strangerLeaveWordInputValue, leaveWordInputValue: leaveWordInputValue, customAreaExtra: customAreaExtra, rightExtra: rightExtra, rightHeaderExtra: rightHeaderExtra, onChangeItem: onChangeItem, onChangeDataAll: onChangeDataAll, maxNumber: maxNumber }));
    }, [
        smallModal,
        customAreaExtra,
        despInputValue,
        extraInputValue,
        leaveWordInputValue,
        onChangeDataAll,
        onChangeItem,
        onInputDespChange,
        onInputExtraChange,
        onInputLeaveWordChange,
        onInputStrangerLeaveWordChange,
        result,
        rightExtra,
        rightHeaderExtra,
        strangerLeaveWordInputValue,
        toggleItem,
    ]);
    var rightStrangerSide = React.useMemo(function () {
        return (React.createElement(RightSide, { data: strangerResult, onItemDelete: function (data) {
                toggleItem(__assign(__assign({}, data), { checked: true }));
            }, onInputLeaveWordChange: onInputLeaveWordChange, onInputStrangerLeaveWordChange: onInputStrangerLeaveWordChange, onInputDespChange: onInputDespChange, onInputExtraChange: onInputExtraChange, despInputValue: despInputValue, extraInputValue: extraInputValue, leaveWordInputValue: leaveWordInputValue, strangerLeaveWordInputValue: strangerLeaveWordInputValue, customAreaExtra: customAreaExtra, rightExtra: rightExtra, rightHeaderExtra: rightHeaderExtra, onChangeItem: onChangeItem, onChangeDataAll: onChangeDataAll, maxNumber: maxNumber }));
    }, [
        customAreaExtra,
        despInputValue,
        extraInputValue,
        leaveWordInputValue,
        onChangeDataAll,
        onChangeItem,
        onInputDespChange,
        onInputExtraChange,
        onInputLeaveWordChange,
        onInputStrangerLeaveWordChange,
        rightExtra,
        rightHeaderExtra,
        strangerLeaveWordInputValue,
        strangerResult,
        toggleItem,
    ]);
    var leftSideNode = React.useMemo(function () {
        switch (newMode) {
            case SelectorMode.group:
                return leftSideFixedUsersRosters;
            case SelectorMode.forward:
                return leftSideFixedUsers;
            case SelectorMode.transfer:
                return leftSideFixedUsers;
            case SelectorMode.stranger:
                return leftSideStrangerUsers;
            default:
                return leftSide;
        }
    }, [leftSide, leftSideFixedUsers, leftSideFixedUsersRosters, leftSideStrangerUsers, newMode]);
    var rightSideNode = React.useMemo(function () {
        switch (newMode) {
            case SelectorMode.stranger:
                return rightStrangerSide;
            default:
                return rightSide;
        }
    }, [newMode, rightSide, rightStrangerSide]);
    if (loading) {
        return React.createElement(Loading, null);
    }
    return (React.createElement(UserSelectionContext.Provider, { value: {
            frozenIds: frozenIds || [],
            t: t,
            fixedUsers: fixedUsers,
            resultUsers: resultUsers || [],
            tabs: chooseOnlyDepart ? ['org'] : filteredTabs,
            single: single,
            dataListFilter: dataListFilter,
            searchPlaceHolder: searchPlaceHolder,
            defaultUserAvatar: defaultUserAvatar,
            onGetAvatarURL: onGetAvatarURL,
            currentUser: currentUser,
            hasItemSelector: hasItemSelector,
            itemSelectorOptions: itemSelectorOptions,
            // customTab,
            // customTab2,
            customTabs: customTabs,
            businessTab: businessTab,
            recommendParam: recommendParam,
            contactsFilterFlag: contactsFilterFlag,
            contactShowType: contactShowType,
            simpleDeptInfoList: simpleDeptInfoList,
            virtualDeptInfoList: virtualDeptInfoList,
            canSelectDept: canSelectDept,
            canSelectAll: canSelectAll,
            onSelectAll: onSelectAll,
            // mode,
            isWebpSupported: isWebpSupported,
            bodyHeight: bodyHeight,
            maxSelectedNum: maxSelectedNum,
            isForwardMode: isForwardMode,
            maxSelectedSingleNum: maxSelectedSingleNum,
            isShowRemark: isShowRemark,
            chooseOnlyDepart: chooseOnlyDepart,
            selectGroupType: selectGroupType,
            selectedCountText: selectedCountText,
            canSelectStranger: canSelectStranger,
            searchValue: searchValue,
            setSearchValue: setSearchValue,
            defaultLimitOpt: defaultLimitOpt,
            selectedLimit: selectedLimit,
            setSelectedLimit: setSelectedLimit,
            maxNumber: maxNumber,
            totalCount: totalCount
        } },
        React.createElement("div", { style: {
                display: 'flex',
                // height:400
                height: bodyHeight,
                position: 'relative',
            } },
            leftSideNode,
            rightSideNode)));
}
//# sourceMappingURL=index.js.map